/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, NgZone, OnDestroy, OnInit} from '@angular/core';

import {AngularResourceListManager} from '../common/controller/angular-resource-list-manager';
import {ApiErrorHandlerService} from '../common/directives/error/api-error-handler.service';
import {AuthHttpInterceptorService} from '../../components/auth/auth-http-interceptor.service';
import {AdnHttpService} from '../../components/util/adn-http.service';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';
import {LocalUserProfile} from '../../components/session/local-user-profile';
import {WINDOW} from '../angular-platform-providers';

@Component({
  standalone: false,
  selector: 'adn-political-entity-route-page',
  template: `
    <adn-political-entity-list-page
      *ngIf="list"
      [list]="list">
    </adn-political-entity-list-page>
  `
})
export class PoliticalEntityRoutePageComponent implements OnInit, OnDestroy {
  list: any;

  private listManager: AngularResourceListManager;

  constructor(
    private readonly AdnHttp: AdnHttpService,
    private readonly authHttpInterceptor: AuthHttpInterceptorService,
    private readonly ApiErrorHandler: ApiErrorHandlerService,
    @Inject(LocalUserProfile) private readonly localUserProfile: any,
    @Inject(WINDOW) private readonly window: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any,
    private readonly ngZone: NgZone
  ) {}

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.canEditPoliticalResources();
    this.listManager = new AngularResourceListManager({
      AdnHttp: this.AdnHttp,
      authHttpInterceptor: this.authHttpInterceptor,
      ApiErrorHandler: this.ApiErrorHandler,
      window: this.window,
      localUserProfile: this.localUserProfile,
      ngZone: this.ngZone
    }, {
      resourcePath: 'politicalentities',
      listId: 'fullPoliticalEntityList',
      defaultOrderByParam: 'name'
    });
    this.list = this.listManager.list;
    this.list.readOnly = readOnly;
    this.listManager.load();
  }

  ngOnDestroy(): void {
    this.listManager?.destroy();
  }
}
